<template lang="pug">
#empresa-tabela-inserir-contrato-originacao
    el-table(
        :data='contratosNaoEnviados',
        v-loading='carregando',
        @sort-change='ordenarContratos',
        @selection-change='handleSelectionChange',
        style='width: 100%'
    )
        el-table-column(type='selection', v-if='removendo', align='center')
        el-table-column(
            prop='numeroContrato',
            label='Nº contrato',
            sortable='custom'
        )
        el-table-column(prop='material', label='Cultura', sortable='custom')
        el-table-column(prop='safraNome', label='Safra', sortable='custom')
        el-table-column(
            prop='volumeContratado',
            label='Vol. vendido',
            sortable='custom'
        )
            .template(slot-scope='scope')
                span {{ scope.row.volumeContratado + ' t' }}
        el-table-column(
            prop='dataContrato',
            label='Data contrato',
            sortable='custom'
        )
        el-table-column(
            prop='subEmpresaNome',
            label='Filial',
            sortable='custom'
        )
        el-table-column(
            prop='clienteNomeRazaoSocial',
            label='Cliente',
            sortable='custom'
        )
        el-table-column(
            prop='clienteCpfCnpj',
            label='CNPJ cliente',
            sortable='custom'
        )
        template(slot='empty')
            el-empty(description='Sem dados')
</template>

<script>
export default {
    name: 'EmpresaTabelaInserirContratoOriginacao',

    props: {
        contratosNaoEnviados: {
            type: Array,
            required: true
        },
        carregando: {
            type: Boolean,
            required: false
        },
        removendo: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            contratosSelecionados: [],
            colunaOrdenacao: {
                numeroContrato: () => 'numero_contrato_valor',
                volumeContratado: () => 'volume_contratado',
                dataContrato: () => 'data_contrato',
                material: () => 'material',
                safraNome: () => 'safraNome',
                subEmpresaNome: () => 'empresaNome',
                clienteNomeRazaoSocial: () => 'clienteNomeRazaoSocial',
                clienteCpfCnpj: () => 'clienteCpfCnpj'
            }
        };
    },

    methods: {
        async handleSelectionChange(dadosContrato) {
            this.contratosSelecionados = dadosContrato;
            const idsContratosOriginacao = this.contratosSelecionados.map(
                contrato => contrato.id
            );

            this.emiteRemoverContratoLote(idsContratosOriginacao);
        },
        emiteRemoverContratoLote(idsContratosOriginacao) {
            this.$emit('contratosSelecionados', idsContratosOriginacao);
        },
        ordenarContratos({ order, prop }) {
            const ordem = order === 'ascending' ? 'asc' : 'desc';
            const coluna = this.colunaOrdenacao[prop]();
            this.$emit('ordenar', `${coluna},${ordem}`);
        }
    }
};
</script>

<style lang="scss">
#empresa-tabela-inserir-contrato-originacao {
    td.el-table__cell.el-table__expanded-cell {
        margin: 0 16px;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        width: 960px;

        .el-descriptions-item__container {
            display: flex;
            flex-direction: column;
            width: fit-content;

            span.el-descriptions-item__label {
                font-weight: bold;
                font-size: 13px;
                color: var(--primary);
            }

            span.el-descriptions-item__content {
                font-size: 12px;
                width: 230px;
            }
        }
    }
    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;
        thead.has-gutter {
            height: 67px;
            th.el-table__cell {
                background-color: #fbfbfb;
            }
        }
    }
    .el-table__cell {
        font-size: 12px;
    }
    .is-leaf {
        font-size: 13px;
    }

    .el-table .cell {
        word-break: normal;
    }
}
</style>
